module.exports = __webpack_public_path__ + "static/media/(V)_MG_5069_-_Pro-Natura_-_Moda_Feminina_-_Moda_Feminina_Infantil.9c5927f1.jpg";